import React, { useState } from 'react';
import FinalizedTpJobsAdmin from '../../../Operations/TpJob/FinalizedTpJobsAdmin';
import InvoiceAutomationReadyBanner from './InvoiceAutomationReadyBanner';

// A project's Ready for Invoicing jobs under the banner of its automatic invoicing. The list loads again once the Run
// Now window closes, as the run may have put some of the jobs on a draft. Only a setup of the project's own gets the
// banner: the Run Now on it runs the project's setup, which a project on another setup's invoice does not have.
export default function InvoiceAutomationReadyForInvoicing({ project = null }) {
  const [listVersion, setListVersion] = useState(0);
  const hasOwnSetup = project.InvoiceAutomationInvoicedWithProjectId == null;

  return (
    <>
      <InvoiceAutomationReadyBanner
        projectId={project.ProjectId}
        projectName={project.ProjectName}
        isActive={hasOwnSetup ? project.InvoiceAutomationIsActive : null}
        runSchedule={project.InvoiceAutomationRunSchedule}
        onRunNowClose={() => setListVersion((version) => version + 1)}
      />
      <FinalizedTpJobsAdmin
        key={listVersion}
        ProjectId={project.ProjectId}
        ClientId={project.BravoClientId}
        SearchType='finalized'
      />
    </>
  );
}
